import { render, staticRenderFns } from "./DetailTStockSlipDeleted.vue?vue&type=template&id=7cb9cd60&"
import script from "./DetailTStockSlipDeleted.vue?vue&type=script&lang=js&"
export * from "./DetailTStockSlipDeleted.vue?vue&type=script&lang=js&"
import style0 from "./DetailTStockSlipDeleted.vue?vue&type=style&index=0&id=7cb9cd60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports